﻿import {RouletteItem} from "./RouletteItem";
import {UINineSlice} from "../Base/UINineSlice";
import {UISprite} from "../Base/UISprite";
import {gsap} from "gsap";
import {RewardType} from "../../../enums";
import {Core} from "../../../Base/Core";

export class Roulette extends UISprite {
    get traveledDistance() {
        // 0 = center of first item in sequence
        return this._traveledDistance;
    }

    set traveledDistance(val) {
        let delta = val - this._traveledDistance;
        this._traveledDistance = val;
        this._renderTraveledDistance();
    }

    Awake() {
        super.Awake();

        this._rect = new PIXI.Rectangle(0, 0, 1, 1);

        this.mask = this.addChild(new PIXI.Graphics()).clear().beginFill(0xffffff, 1).drawRect(0, 0, 1, 1);

        this.back = this.addChild(new UINineSlice("particles/rect"));
        this.back.tint = 0x000000;
        this.back.alpha = 0.3;

        this.items = []; // List<RouletteItem>
        this.targetReward = null; // ChestItem
        this.callback = null; // Action
        this.spin = false;

        for (let i = 0; i < 9; i++) {
            let newItem = this.addChild(new RouletteItem());
            this.items.push(newItem);
        }

        this.cursor = this.addChild(new PIXI.Graphics()).beginFill(0xffffff, 1).drawRect(-2, 0, 4, 1);

        this.itemSize = 0;
        this.totalWidth = 0;
        this._traveledDistance = 0; // 0 = centered on 1-st item, 1 = centered on 2-nd item
        this.sequence = [];

        this.reset();
        this._generateSequence();
    }

    Init(targetReward, callback) {
        if (!targetReward) {
            // Random good reward
            targetReward = Core.GameData.Chest.GetRandomReverse();
        }
        this.callback = callback;
        this.targetReward = targetReward;
        this.reset();
    }

    reset() {
        if (this.spinning) {
            this.spinning.kill();
            this.spinning = null;
        }
        this.sequence.splice(0);
        this._generateSequence();
        this._traveledDistance = 0;
        for (let item of this.items) {
            item.ClearChooseAnimation();
        }
    }

    fitLayout(parentRect = this._rect) {
        this._rect.copyFrom(parentRect);
        // X-centered for convenient zero-position under cursor
        this.position.set(parentRect.x + parentRect.width * 0.5, parentRect.y);

        let rect = parentRect.clone();
        rect.x = -rect.width * 0.5;
        rect.y = 0;

        let maskRect = rect.clone().pad(0, rect.height * 1.05);
        this.mask.position.copyFrom(maskRect);
        this.mask.width = maskRect.width;
        this.mask.height = maskRect.height;

        this.back.fitLayout(rect);

        this.itemSize = rect.height;
        this.totalWidth = this.items.length * this.itemSize;

        this.cursor.position.set(-2, 0);
        this.cursor.height = rect.height;

        this._renderTraveledDistance();
    }

    _generateSequence() {
        let length = 50;
        this.sequence = [];
        while (this.sequence.length < length) {
            this.sequence.push(Core.GameData.Chest.GetRandom());
        }
        this._truncateTraveledDistance();
        if (this.targetReward) {
            this.sequence[length - 4] = this.targetReward;
        }
        this._renderTraveledDistance();
    }

    _truncateTraveledDistance() {
        this._traveledDistance = Math.round(this._traveledDistance);
        if (this._traveledDistance === 0) return; // already on zero
        while (this._traveledDistance < 0) this._traveledDistance += this.sequence.length;
        while (this._traveledDistance > this.sequence.length) this._traveledDistance -= this.sequence.length;
        while (this._traveledDistance > 0) {
            this.sequence.push(this.sequence.shift());
            this._traveledDistance--;
        }
    }

    _renderTraveledDistance() {
        // 0 = center of first item in sequence
        let currentItemIndex = Math.round(this._traveledDistance);
        let midItem = Math.floor(this.items.length / 2);
        let startIndex = currentItemIndex - midItem;
        if (startIndex < 0) {
            startIndex += this.sequence.length;
        }

        let sequence = this.sequence.slice(startIndex, startIndex + this.items.length);
        if (sequence.length < this.items.length) {
            sequence.push(...this.sequence.slice(0, this.items.length - sequence.length));
        }

        let itemSize = this._rect.height;
        let cellRect = new PIXI.Rectangle(itemSize * (this.items.length * 0.5 - 1), 0, itemSize, itemSize);
        let offset = Math.round(this._traveledDistance) - this._traveledDistance;
        for (let i = this.items.length - 1; i >= 0; i--) {
            this.items[i].SetItem(sequence[sequence.length - i - 1]);
            this.items[i].fitLayout(cellRect);
            this.items[i].pivot.x = offset * itemSize;
            cellRect.x -= itemSize;
        }
    }

    run() {
        this.traveledDistance = 0;
        console.log("REWARD", RewardType[this.targetReward.type], this.targetReward.value || this.targetReward.valueInt);
        this._generateSequence();
        let target = (this.sequence.length - 4) + 0.45 - Math.random() * 0.9;
        let prevDistance = this.traveledDistance;
        this.spinning = gsap.timeline()
            .to(this, {
                traveledDistance: target,
                duration: 4,
                ease: "circ.out"
            })
            .eventCallback("onUpdate", () => {
                let d = Math.ceil(this.traveledDistance);
                if (prevDistance !== d) {
                    prevDistance = d;
                    Core.Audio.Play("SpinTic");
                }
            })
            .eventCallback("onComplete", () => {
                this.spinning = null;
                this.items[~~(this.items.length / 2)].PlayChooseAnimation();
                this.callback();
            })
        ;
    }
}
